import React, { useState, useCallback, useRef, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import { LoadPanel } from 'devextreme-react/load-panel';
import Toolbar, { Item } from "devextreme-react/toolbar";
import PrimaryTab from "./tabs/PrimaryTab";
import UserDefinedTab from "./tabs/UserDefinedTab";
import DetailsTab from "./tabs/DetailsTab";
import axios from "axios";
import data from "../../../assets/apiRoutes.json";
import { confirm } from 'devextreme/ui/dialog';
import { custom } from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';
import { MESSAGES } from '../../../common/Messages';

const BASE31_ALPHABET = '0123456789BCDFGHJKLMNPQRSTVWXYZ';
function intToRecordNumber(keySequence) {
    if (keySequence == null) return '';
    let num = keySequence + 2147483647;
    if (num === 0) return '0';
    let result = '';
    while (num > 0) {
        result = BASE31_ALPHABET[num % 31] + result;
        num = Math.floor(num / 31);
    }
    return result;
}

function Form(props) {
    const history = useHistory();
    const formRefs = useRef({});
    const initialFormFields = {
        RowId: '00000000-0000-0000-0000-000000000000',
        RECORD: '',
        Module: 'ID',
        RProfile: null,
        TaxCode: '',
        Description1: '',
        Description2: '',
        Status: 'A',
        Comment: '',
        ApplyOnTax1: 'N',
        RIdFuelAndMiscTaxes: null,
        PopupMessage: '',
        UserDefinedCode1: '',
        UserDefinedCode2: '',
        UserDefinedCode3: '',
        UserDefinedCode4: '',
        UserDefinedCode5: '',
        UserDefinedCode6: '',
        UserDefinedCode7: '',
        UserDefinedCode8: '',
        UserDefinedCode9: '',
        UserDefinedCode10: '',
        UserDefinedDate1: null,
        UserDefinedDate2: null,
        UserDefinedDate3: null,
        UserDefinedDate4: null,
        UserDefinedDate5: null,
        UserDefinedDate6: null,
        UserDefinedDate7: null,
        UserDefinedDate8: null,
        UserDefinedDate9: null,
        UserDefinedDate10: null,
        UserDefinedQuantity1: null,
        UserDefinedQuantity2: null,
        UserDefinedQuantity3: null,
        UserDefinedQuantity4: null,
        UserDefinedQuantity5: null,
        UserDefinedQuantity6: null,
        UserDefinedQuantity7: null,
        UserDefinedQuantity8: null,
        UserDefinedQuantity9: null,
        UserDefinedQuantity10: null,
        UserDefinedReference1: '',
        UserDefinedReference2: '',
        UserDefinedReference3: '',
        UserDefinedReference4: '',
        UserDefinedReference5: '',
        UserDefinedReference6: '',
        UserDefinedReference7: '',
        UserDefinedReference8: '',
        UserDefinedReference9: '',
        UserDefinedReference10: '',
        UserDefinedComment: '',
        AsOfDate: new Date().toISOString().split('T')[0],
        TotalRate: 0,
    };
    const [formFields, setformFields] = useState(initialFormFields);
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [templateHeaderRowId, setTemplateHeaderRowId] = useState(null);
    const accessToken = props?.oidc?.user?.access_token;

    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, []);

    const position = { of: '#accordion' };

    const handleProfileChange = useCallback(async (profileRowId) => {
        if (!profileRowId || formFields.RowId !== '00000000-0000-0000-0000-000000000000') {
            return;
        }
        try {
            setLoadPanelVisible(true);
            const url = `${window._env_.REACT_APP_APIS}/${data.ID?.GetTaxProfileTemplate || 'id/TaxHeader/GetTaxProfileTemplate'}?profileRowId=${profileRowId}`;
            const response = await axios.get(url, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            });
            if (response.data) {
                const template = response.data;
                setformFields(prevFields => ({
                    ...prevFields,
                    Description1: template.Description1 || prevFields.Description1,
                    Description2: template.Description2 || prevFields.Description2,
                    Status: template.Status || prevFields.Status,
                    Comment: template.Comment || prevFields.Comment,
                    ApplyOnTax1: template.ApplyOnTax1 || prevFields.ApplyOnTax1,
                    PopupMessage: template.PopupMessage || prevFields.PopupMessage,
                    RIdFuelAndMiscTaxes: template.RIdFuelAndMiscTaxes || prevFields.RIdFuelAndMiscTaxes,
                    UserDefinedCode1: template.UserDefinedCode1 || prevFields.UserDefinedCode1,
                    UserDefinedCode2: template.UserDefinedCode2 || prevFields.UserDefinedCode2,
                    UserDefinedCode3: template.UserDefinedCode3 || prevFields.UserDefinedCode3,
                    UserDefinedCode4: template.UserDefinedCode4 || prevFields.UserDefinedCode4,
                    UserDefinedCode5: template.UserDefinedCode5 || prevFields.UserDefinedCode5,
                    UserDefinedCode6: template.UserDefinedCode6 || prevFields.UserDefinedCode6,
                    UserDefinedCode7: template.UserDefinedCode7 || prevFields.UserDefinedCode7,
                    UserDefinedCode8: template.UserDefinedCode8 || prevFields.UserDefinedCode8,
                    UserDefinedCode9: template.UserDefinedCode9 || prevFields.UserDefinedCode9,
                    UserDefinedCode10: template.UserDefinedCode10 || prevFields.UserDefinedCode10,
                    UserDefinedDate1: template.UserDefinedDate1 || prevFields.UserDefinedDate1,
                    UserDefinedDate2: template.UserDefinedDate2 || prevFields.UserDefinedDate2,
                    UserDefinedDate3: template.UserDefinedDate3 || prevFields.UserDefinedDate3,
                    UserDefinedDate4: template.UserDefinedDate4 || prevFields.UserDefinedDate4,
                    UserDefinedDate5: template.UserDefinedDate5 || prevFields.UserDefinedDate5,
                    UserDefinedDate6: template.UserDefinedDate6 || prevFields.UserDefinedDate6,
                    UserDefinedDate7: template.UserDefinedDate7 || prevFields.UserDefinedDate7,
                    UserDefinedDate8: template.UserDefinedDate8 || prevFields.UserDefinedDate8,
                    UserDefinedDate9: template.UserDefinedDate9 || prevFields.UserDefinedDate9,
                    UserDefinedDate10: template.UserDefinedDate10 || prevFields.UserDefinedDate10,
                    UserDefinedQuantity1: template.UserDefinedQuantity1 ?? prevFields.UserDefinedQuantity1,
                    UserDefinedQuantity2: template.UserDefinedQuantity2 ?? prevFields.UserDefinedQuantity2,
                    UserDefinedQuantity3: template.UserDefinedQuantity3 ?? prevFields.UserDefinedQuantity3,
                    UserDefinedQuantity4: template.UserDefinedQuantity4 ?? prevFields.UserDefinedQuantity4,
                    UserDefinedQuantity5: template.UserDefinedQuantity5 ?? prevFields.UserDefinedQuantity5,
                    UserDefinedQuantity6: template.UserDefinedQuantity6 ?? prevFields.UserDefinedQuantity6,
                    UserDefinedQuantity7: template.UserDefinedQuantity7 ?? prevFields.UserDefinedQuantity7,
                    UserDefinedQuantity8: template.UserDefinedQuantity8 ?? prevFields.UserDefinedQuantity8,
                    UserDefinedQuantity9: template.UserDefinedQuantity9 ?? prevFields.UserDefinedQuantity9,
                    UserDefinedQuantity10: template.UserDefinedQuantity10 ?? prevFields.UserDefinedQuantity10,
                    UserDefinedReference1: template.UserDefinedReference1 || prevFields.UserDefinedReference1,
                    UserDefinedReference2: template.UserDefinedReference2 || prevFields.UserDefinedReference2,
                    UserDefinedReference3: template.UserDefinedReference3 || prevFields.UserDefinedReference3,
                    UserDefinedReference4: template.UserDefinedReference4 || prevFields.UserDefinedReference4,
                    UserDefinedReference5: template.UserDefinedReference5 || prevFields.UserDefinedReference5,
                    UserDefinedReference6: template.UserDefinedReference6 || prevFields.UserDefinedReference6,
                    UserDefinedReference7: template.UserDefinedReference7 || prevFields.UserDefinedReference7,
                    UserDefinedReference8: template.UserDefinedReference8 || prevFields.UserDefinedReference8,
                    UserDefinedReference9: template.UserDefinedReference9 || prevFields.UserDefinedReference9,
                    UserDefinedReference10: template.UserDefinedReference10 || prevFields.UserDefinedReference10,
                    UserDefinedComment: template.UserDefinedComment || prevFields.UserDefinedComment,
                    RProfile: profileRowId,
                }));
                if (template.RowId) {
                    setTemplateHeaderRowId(template.RowId);
                }
            }
        } catch (error) {
            console.error('Error loading profile template:', error);
        } finally {
            setLoadPanelVisible(false);
        }
    }, [accessToken, formFields.RowId]);

    const handleFieldChange = useCallback((name, value) => {
        setformFields(prevFields => ({
            ...prevFields,
            [name]: value
        }));
        if (name === 'RProfile' && value) {
            handleProfileChange(value);
        }
    }, [handleProfileChange]);

    const loadById = useCallback(async (rowId) => {
        if (!rowId || rowId === '00000000-0000-0000-0000-000000000000') {
            return;
        }

        try {
            setLoadPanelVisible(true);
            const url = `${window._env_.REACT_APP_APIS}/${data.ID?.GetTaxHeader || 'id/TaxHeader/GetTaxHeader'}?rowId=${rowId}`;
            const response = await axios.get(url, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            });

            if (response.data) {
                const loaded = response.data;
                if (loaded.KeySequence != null && !loaded.RECORD) {
                    loaded.RECORD = intToRecordNumber(loaded.KeySequence);
                }
                loaded.AsOfDate = loaded.AsOfDate || new Date().toISOString().split('T')[0];
                loaded.TotalRate = loaded.TotalRate || 0;
                setformFields(loaded);
            }
        } catch (error) {
            console.error('Error loading data:', error);
            notify('Failed to load Sales Tax Code data.', 'error', 3000);
        } finally {
            setLoadPanelVisible(false);
        }
    }, [accessToken]);

    useEffect(() => {
        const rowId = props.id;
        if (rowId && rowId !== '00000000-0000-0000-0000-000000000000') {
            loadById(rowId);
        }
    }, [props.id, loadById]);

    const calculateTotalRate = useCallback(async () => {
        if (!formFields.RowId || formFields.RowId === '00000000-0000-0000-0000-000000000000') {
            setformFields(prev => ({ ...prev, TotalRate: 0 }));
            return;
        }
        try {
            const url = `${window._env_.REACT_APP_APIS}/${data.ID?.GetTaxDetails || 'id/TaxDetail/GetTaxDetails'}?headerRowId=${formFields.RowId}`;
            const response = await axios.get(url, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            });
            const details = response.data?.data || response.data || [];
            const asOfDateObj = new Date(formFields.AsOfDate || new Date());
            asOfDateObj.setHours(0, 0, 0, 0);
            const total = details
                .filter(d => {
                    const start = d.EffectiveDateStart ? new Date(d.EffectiveDateStart) : null;
                    const end = d.EffectiveDateEnd ? new Date(d.EffectiveDateEnd) : null;
                    if (start) start.setHours(0, 0, 0, 0);
                    if (end) end.setHours(0, 0, 0, 0);
                    return (!start || start <= asOfDateObj) && (!end || end >= asOfDateObj);
                })
                .reduce((sum, d) => sum + (d.TaxRate || 0), 0);
            setformFields(prev => ({ ...prev, TotalRate: total }));
        } catch (error) {
            console.error('Error calculating total rate:', error);
        }
    }, [formFields.RowId, formFields.AsOfDate, accessToken]);

    useEffect(() => {
        calculateTotalRate();
    }, [calculateTotalRate]);

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        setIsFormSubmitted(true);
        setLoadPanelVisible(true);

        try {
            const isUpdate = formFields.RowId && formFields.RowId !== "00000000-0000-0000-0000-000000000000";
            const endpoint = isUpdate
                ? (data.ID?.UpdateTaxHeader || 'id/TaxHeader/UpdateTaxHeader')
                : (data.ID?.InsertTaxHeader || 'id/TaxHeader/InsertTaxHeader');
            const method = isUpdate ? 'put' : 'post';

            const url = `${window._env_.REACT_APP_APIS}/${endpoint}`;
            const { AsOfDate, TotalRate, ...submitFields } = formFields;
            const payload = isUpdate ? submitFields : { ...submitFields, TemplateHeaderRowId: templateHeaderRowId };
            const response = await axios[method](url, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });

            if (response.data && (!response.data.ERRORS || response.data.ERRORS.length === 0)) {
                if (!isUpdate && response.data.ROWID) {
                    setformFields(prevFields => ({
                        ...prevFields,
                        RowId: response.data.ROWID,
                        RECORD: response.data.RECORD || prevFields.RECORD,
                    }));
                }
                notify(
                    {
                        message: isUpdate ? (MESSAGES.UPDATE_SUCCESS || "Sales Tax Code Updated Successfully") : (MESSAGES.INSERT_SUCCESS || "Sales Tax Code Created Successfully"),
                        width: 300,
                    },
                    'success',
                    3000,
                );
            } else {
                const errors = response.data?.ERRORS || ['An error occurred'];
                const errorHtml = errors.map(err => `<div>${err}</div>`).join('');
                custom({
                    title: "Errors",
                    messageHtml: errorHtml,
                    buttons: [{ text: "OK", onClick: () => { } }]
                }).show();
            }
        } catch (error) {
            console.error('Error saving:', error);
            if (error.response?.data?.ERRORS && error.response.data.ERRORS.length > 0) {
                const errorHtml = error.response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                custom({
                    title: "Errors",
                    messageHtml: errorHtml,
                    buttons: [{ text: "OK", onClick: () => { } }]
                }).show();
            } else {
                notify(
                    {
                        message: MESSAGES.INSERT_ERROR || "Could not save. An error occurred",
                        width: 450,
                    },
                    'error',
                    3000,
                );
            }
        } finally {
            hideLoadPanel();
            setIsFormSubmitted(false);
        }
    };

    const addNewRecordClick = () => {
        setformFields(initialFormFields);
        history.push('/om/codes/sales-tax-code-data-entry-create');
    };

    const DeleteClick = () => {
        if (!formFields.RowId || formFields.RowId === "00000000-0000-0000-0000-000000000000") {
            notify("No record selected for deletion.", "warning", 3000);
            return;
        }

        let result = confirm("<i>Are you sure you want to delete this Sales Tax Code?</i>", "Delete");
        result.then(async (dialogResult) => {
            if (dialogResult) {
                setLoadPanelVisible(true);
                try {
                    const url = `${window._env_.REACT_APP_APIS}/${data.ID?.DeleteTaxHeader || 'id/TaxHeader/DeleteTaxHeader'}`;
                    const formData = new FormData();
                    formData.append('rowId', formFields.RowId);
                    const response = await axios.delete(url, {
                        data: formData,
                        headers: {
                            access_token: accessToken,
                            Authorization: `Bearer ${accessToken}`,
                        }
                    });

                    if (response.data && response.data.Success) {
                        notify("Sales Tax Code deleted successfully.", "success", 3000);
                        setformFields(initialFormFields);
                        setTimeout(() => {
                            history.push("/om/codes/sales-tax-code-data-entry-list");
                        }, 1000);
                    } else {
                        notify(response.data?.message || "Failed to delete Sales Tax Code.", "error", 3000);
                    }
                } catch (error) {
                    const message = error?.response?.data?.message || error?.message || "An error occurred while deleting.";
                    notify(message, "error", 5000);
                } finally {
                    setLoadPanelVisible(false);
                }
            }
        });
    };

    const handleReset = () => {
        const rowId = props.id;
        if (rowId && rowId !== '00000000-0000-0000-0000-000000000000') {
            loadById(rowId);
        } else {
            setformFields(initialFormFields);
        }
    };

    const goBack = () => {
        history.push("/om/codes/sales-tax-code-data-entry-list");
    };

    return (
        <div>
            <div className="row dataEntryMainPage">
                <div className="col-md-12 main-page">
                    <div id="accordion">
                        <LoadPanel
                            shadingColor="rgba(0,0,0,0.4)"
                            position={position}
                            onHiding={hideLoadPanel}
                            visible={loadPanelVisible}
                            showIndicator={true}
                            shading={true}
                            showPane={true}
                            hideOnOutsideClick={false}
                        />
                        <form onSubmit={(e) => handleFormSubmit(e)}>
                            <Toolbar className="header">
                                <Item location="before">
                                    <div className="title">
                                        <h6
                                            style={{
                                                color: window._env_.Color2,
                                                marginLeft: '12px'
                                            }}
                                        >
                                            Enter Sales Tax Code{formFields.TaxCode ? ` - ${formFields.TaxCode}` : ''}
                                        </h6>
                                    </div>
                                </Item>
                                <Item location="after">
                                    <Button
                                        text="Save"
                                        useSubmitBehavior={true}
                                        disabled={isFormSubmitted}
                                        type="default"
                                        className="accordianButton"
                                    />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={addNewRecordClick} text="New" type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={DeleteClick} text="Delete" disabled={formFields.RowId === "00000000-0000-0000-0000-000000000000"} type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={goBack} text="Back" />
                                </Item>
                            </Toolbar>
                            <TabPanel deferRendering={props.id ? true : false} showNavButtons={true} height={"auto"}>
                                <TabItem title="Primary">
                                    <PrimaryTab
                                        formFields={formFields}
                                        setformFields={setformFields}
                                        formRefs={formRefs}
                                        handleFieldChange={handleFieldChange}
                                    />
                                </TabItem>
                                <TabItem title="User Defined">
                                    <UserDefinedTab
                                        formFields={formFields}
                                        setformFields={setformFields}
                                        handleFieldChange={handleFieldChange}
                                    />
                                </TabItem>
                                <TabItem title="Details" disabled={formFields.RowId === '00000000-0000-0000-0000-000000000000'}>
                                    <DetailsTab
                                        headerId={formFields.RowId}
                                        onDetailsSaved={calculateTotalRate}
                                    />
                                </TabItem>
                            </TabPanel>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(Form);
